//
// WARNING: this file was auto-generated by @phensley/cldr-compiler. DO NOT EDIT.
//
/* eslint-disable max-len */
export var grandfatheredRaw = 'art-lojban:jbo|cel-gaulish:|en-GB-oed:en-GB-oxendict|i-ami:ami|i-bnn:bnn|i-default:|i-enochian:|i-hak:hak|i-klingon:tlh|i-lux:lb|i-mingo:|i-navajo:nv|i-pwn:pwn|i-tao:tao|i-tay:tay|i-tsu:tsu|no-bok:nb|no-nyn:nn|sgn-BE-FR:sfb|sgn-BE-NL:vgt|sgn-CH-DE:sgg|zh-guoyu:cmn|zh-hakka:hak|zh-min:|zh-min-nan:nan|zh-xiang:hsn';
//# sourceMappingURL=autogen.subtags.js.map